import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=6b18401a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=6b18401a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18401a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b18401a')) {
      api.createRecord('6b18401a', component.options)
    } else {
      api.reload('6b18401a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=6b18401a&scoped=true&", function () {
      api.rerender('6b18401a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-48xPZcjXFEuVU/JS/comp/Paginate.vue"
export default component.exports